module.exports = __webpack_public_path__ + "static/media/nessa-lose.3fd24648.png";